import { Component } from '@angular/core';

@Component({
  selector: 'app-die-casting',
  templateUrl: './die-casting.component.html',
  styleUrls: ['./die-casting.component.scss']
})
export class DieCastingComponent {
  advanceMoullding:any[] = [
    {
      title: 'Sand Casting',
      img: 'assets/images/capability/blue/metal_casting_1.JPG',
    },
    {
      title: 'Die Casting',
      img: 'assets/images/capability/blue/metal_casting_2.JPG',
    },
    {
      title: 'Turning Centers',
      img: 'assets/images/capability/blue/metal_casting_3.JPG',
    },
    {
      title: 'Machining Centers',
      img: 'assets/images/capability/blue/metal_casting_4.JPG',
    },
    {
      title: 'Liquid Painting',
      img: 'assets/images/capability/blue/metal_casting_5.JPG',
    },
    {
      title: 'Power Coating​',
      img: 'assets/images/capability/blue/metal_casting_6.JPG',
    },
    {
      title: 'Anodizing​',
      img: 'assets/images/capability/blue/metal_casting_7.JPG',
    }
  ]

  produtimglist:any[] = [
    {
      img: 'assets/images/capability/blue/product-image-one.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-one.png',
    },    
  ]
  
  produtitemlist:any[] = [
    { 'item': 'Gear Rims'},
    { 'item': 'Heat Sinks'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'Pistons'},
    { 'item': 'Disc Valve / Port plate'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'Sleeve & Spool'},
    { 'item': 'Sub Assembly'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
  ]

  produtitemlistone:any[] = [
    { 'item': 'TiN'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'TiCN'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'TiAlN'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
  ]
  
  rawmaterial:any[] = [
    { 'item': 'Iron'},
    { 'item': 'Aluminum'},
    { 'item': 'Zinc'},
  ]
  diamension:any[] = [
    { 'item': 'Upto 2500 Tonne'},
    { 'item': 'Part Weight: Upto 100Kgs'},
  ]

  accuracy:any[] = [
     { 'item':'Die Casting : (a) High-pressure (HPDC) (b) Low-pressure (LPDC) (c) Gravity (GDC) '},
     { 'item':'Sand Casting'},
     { 'item':'Machining Fixtures'},
    //  { 'item':'Straightness-1 micron'},
    //  { 'item':'Roundness-1 micron'}
  ]

  surfacetreatment:any[] = [
    { 'item':'Liquid Painting'},
    { 'item':'Powder Coating'},
    { 'item':'Anodizing for Aluminum'},
    { 'item':'Solution Ageing'},
    // { 'item':'Electroless Nickel Plating (In-house)'}
 ]
}
